// Carili Firma Faturaları sayfasının tüm renkleri burada toplanır.
// Renk revizesi gerektiğinde yalnızca bu dosya düzenlenmelidir; styled-components
// (SubCompanyInvoice.styles.js) renkleri doğrudan buradan okur.
export const invoiceTheme = {
    // Alt firma satırı açıldığında iki fatura kutusunun arkasında kalan dış alan
    expandedRowBackground: "#f5f6f8",

    // Firma açıldığında alt firma satırları (Kredi Hareketleri'ndeki tarih satırlarıyla aynı görünüm)
    subCompanyRows: {
        background: "#d4d4d4", // Satırların arasında ve çevresinde kalan gri zemin
        rowBackground: "#ffffff", // Alt firma satırının zemini
        rowHoverBackground: "#fafafa", // Satırın üzerine gelindiğinde zemin
        iconBackground: "rgb(126, 126, 126)", // Soldaki ikon kutusu
        icon: "#ffffff",
        label: "#888888", // "Proje Kodu", "Toplam Fatura Tutarı" gibi etiketler
        value: "#333333", // Etiketlerin altındaki / yanındaki değerler
        arrow: "#999999" // Aç/kapa oku
    },

    // "Kesilmesi Beklenen Cod Faturaları" kutusu (mavi tonlar)
    cod: {
        outerBorder: "#c7d2f0", // Kutunun dış çerçevesi
        outerShadow: "rgba(92, 115, 196, 0.18)", // Kutunun dış katmanındaki gölge
        outerBackground: "#eef2fc", // Kutu gövdesi: iç tablonun etrafındaki boşluk
        headerBackground: "#e6ecfa", // Kutu başlık şeridi (ikon + başlık + "N fatura")
        headerBorder: "#d3dcf3", // Başlık şeridi ile tablo arasındaki çizgi
        headerText: "#1f1f1f", // Başlık yazısı, ikon ve aç/kapa oku
        countText: "#595959", // Sağdaki "N fatura" yazısı
        tableHeaderBackground: "#d6def5", // İç tablonun kolon başlık satırı zemini
        tableHeaderText: "#1f1f1f", // İç tablonun kolon başlık yazısı
        tableRowBackground: "#ffffff", // İç tablonun veri satırları zemini
        tableRowHoverBackground: "#f5f7fd", // İç tablo satırının üzerine gelindiğinde zemin
        tableRowBorder: "#e8e8e8" // İç tablo satırları arasındaki çizgi
    },

    // "Vigo Hizmet Faturaları" kutusu (bej tonlar) — alanların anlamı cod ile aynıdır
    service: {
        outerBorder: "#e6d5c3",
        outerShadow: "rgba(166, 128, 89, 0.18)",
        outerBackground: "#faf5ef",
        headerBackground: "#f7efe6",
        headerBorder: "#eee0d0",
        headerText: "#1f1f1f",
        countText: "#595959",
        tableHeaderBackground: "#ecdcc9",
        tableHeaderText: "#1f1f1f",
        tableRowBackground: "#ffffff",
        tableRowHoverBackground: "#fcf8f3",
        tableRowBorder: "#eee4d8"
    },

    detailIcon: "#1f1f1f", // Vigo Hizmet tablosundaki kredi hareketleri detay ikonu
    detailIconHover: "#1890ff", // Detay ikonunun üzerine gelindiğindeki rengi

    statCardBackground: "#f5f5f5", // Özet kartlarının zemini (tüm kartlarda aynı gri)
    statCardBorder: "#ebebeb", // Özet kartlarının çerçevesi
    statValue: "#1f1f1f", // Özet kartlarındaki tutar / sayı yazısı
    statLabel: "#262626", // Özet kartlarındaki başlık yazısı
    statBadgeBackground: "#DCE6F8", // İkonun köşesindeki sayı rozeti
    statBadgeText: "#262626",
    statBadgeBorder: "#ffffff",

    // Özet kartlarında yalnızca ikon renklidir; kart sırasıyla aynı sıradadır
    stats: {
        calculatedAmount: {
            iconBackground: "#E8F5EE", // Soft Mint: ikonun arkasındaki yuvarlak köşeli kutu
            icon: "#239B62" // İkon rengi
        },
        calculatedCount: {
            iconBackground: "#E8F0FA", // Soft Blue
            icon: "#3B73C4"
        },
        issuedAmount: {
            iconBackground: "#F0EBF8", // Soft Lavender
            icon: "#8064A2"
        },
        issuedCount: {
            iconBackground: "#FBEDE3", // Soft Peach
            icon: "#D9824B"
        },
        pendingAmount: {
            iconBackground: "#F9E8EC", // Soft Rose
            icon: "#C85C70"
        },
        pendingCount: {
            iconBackground: "#F8F0DD", // Soft Sand
            icon: "#B58A32"
        }
    }
};
